import React from 'react';
import classNames from 'classnames';
import PenalizedFilterLabel from './components/PenalizedFilterLabel/PenalizedFilterLabel';
import styles from './hotelCardPenalizedFilters.module.css';

type HotelCardPenalizedFiltersProps = {
  penalizedFilters: string[];
  isMobile: boolean;
};

const HotelCardPenalizedFilters: React.FC<HotelCardPenalizedFiltersProps> = ({
  penalizedFilters,
  isMobile,
}) =>
  penalizedFilters.length > 0 ? (
    <div
      className={classNames(styles.penalizedFilters, {
        [styles.penalizedFiltersMobile]: isMobile,
      })}
    >
      {penalizedFilters.map((filterName) => (
        <PenalizedFilterLabel key={filterName}>
          {filterName}
        </PenalizedFilterLabel>
      ))}
    </div>
  ) : null;

export default HotelCardPenalizedFilters;
